import { render, staticRenderFns } from "./LunchMenuList.vue?vue&type=template&id=37dbd1f8&scoped=true&"
import script from "./LunchMenuList.vue?vue&type=script&lang=js&"
export * from "./LunchMenuList.vue?vue&type=script&lang=js&"
import style0 from "./LunchMenuList.vue?vue&type=style&index=0&id=37dbd1f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dbd1f8",
  null
  
)

export default component.exports